import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "timer-text" }


import { IonBadge } from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentBadges',
  props: {
  label: { type: String, required: true },
  time: { type: Number },
  timeUnit: { type: String },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonBadge), {
      color: "secondary",
      "data-test": "label-badge"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(props.label), 1)
      ]),
      _: 1
    }),
    (props.time)
      ? (_openBlock(), _createBlock(_unref(IonBadge), {
          key: 0,
          id: "timer",
          "data-test": "timer-badge"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_1, _toDisplayString(props.time + " " + props.timeUnit), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})